import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: ${myPalette.white.main};
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  gap: 16px;
`
